import Service from '@/utils/request';

/**
 * 统计配送总数和日均值
 * @param params 请求参数对象
 *
 */
const statisticsTotalData = (params) => Service.get('/biz/delivery/statistics/totalData', {
    params: {
        ...params,
        appCode: 'WL',
    },
});

/**
 * 统计配送时效数据
 * @param params 请求参数对象
 *
 */
const statisticsEfficiency = (params) => Service.get('/biz/delivery/statistics/efficiency', {
    params: {
        ...params,
        appCode: 'WL',
    },
});
/**
 * 统计近期趋势数据，如近7天配送费、订单数、外卖数等。
 * @param params 请求参数对象
 *
 */
const statisticsLineChart = (params) => Service.get('/biz/delivery/statistics/lineChart', {
    params: {
        ...params,
        appCode: 'WL',
    },
});

export default {
    statisticsTotalData,
    statisticsEfficiency,
    statisticsLineChart,
};
